export function validarSenhaSegura(senha) {
  const criterios = [
    {
      texto: "Mínimo de 6 caracteres",
      valido: senha.length >= 6,
    },
    {
      texto: "Pelo menos uma letra maiúscula (A)",
      valido: /[A-Z]/.test(senha),
    },
    {
      texto: "Pelo menos uma letra minúscula (a)",
      valido: /[a-z]/.test(senha),
    },
    {
      texto: "Pelo menos 1 número (4)",
      valido: /[0-9]/.test(senha),
    },
    {
      texto: "Pelo menos um caractere especial (@)",
      valido: /[^A-Za-z0-9]/.test(senha),
    },
  ];

  const htmlFeedback = `<p>A senha deve atender os seguintes requisitos:</p>
  <ul style="text-align: left; margin-left: 1rem;">
    ${criterios
      .map(
        (c) =>
          `<li style="color: ${c.valido ? "green" : "red"};">${c.texto}</li>`
      )
      .join("")}
  </ul>`;

  const senhaValida = criterios.every((c) => c.valido);

  return { valido: senhaValida, htmlFeedback };
}

